module.exports = __WEBPACK_EXTERNAL_MODULE_H_qB__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react-redux","commonjs2":"react-redux","amd":"react-redux","root":"ReactRedux"}
// module id = H/qB
// module chunks = 0